import { useState, useEffect } from 'react';
import API from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { toast } from 'sonner';

export function DedupeDialog({ open, onOpenChange, onMerged }) {
  const [groups, setGroups] = useState(null);
  const [primary, setPrimary] = useState({});
  const load = () => API.post('/buyers/dedupe-preview').then(r => {
    setGroups(r.data.groups); setPrimary(Object.fromEntries(r.data.groups.map((g, i) => [i, g.suggested_primary])));
  });
  useEffect(() => { if (open) { setGroups(null); load(); } }, [open]);
  const merge = async (g, i) => {
    try {
      await API.post('/buyers/merge', { primary_id: primary[i], merge_ids: g.buyers.map(b => b.id).filter(id => id !== primary[i]) });
      toast.success('Merged'); load(); onMerged();
    } catch (e) { toast.error(e.response?.data?.detail || 'Merge failed'); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white max-w-xl max-h-[85vh] overflow-y-auto" data-testid="dedupe-dialog">
        <DialogHeader><DialogTitle>Possible Duplicate Buyers</DialogTitle></DialogHeader>
        <p className="text-xs text-gray-500">Grouped by same normalized name, Sunbiz Doc #, phone or email. Pick the record to keep — contacts, purchases and history move into it.</p>
        {groups === null ? <div className="h-20 bg-gray-100 rounded animate-pulse" /> : groups.length === 0 ? <p className="text-sm text-gray-400 text-center py-6" data-testid="no-duplicates">No duplicates found.</p> : groups.map((g, i) => (
          <div key={i} className="border border-gray-200 rounded-lg p-3 space-y-1.5" data-testid={`dupe-group-${i}`}>
            {g.buyers.map(b => (
              <label key={b.id} className="flex items-center gap-2 text-sm cursor-pointer">
                <input type="radio" name={`p${i}`} checked={primary[i] === b.id} onChange={() => setPrimary(p => ({ ...p, [i]: b.id }))} />
                <span className="flex-1">{b.entity_name} <span className="text-xs text-gray-400">{b.sunbiz_doc_number} {b.email}</span></span>
                <span className="text-xs text-gray-500">{b.total_purchases_24mo || 0} buys</span>
              </label>
            ))}
            <Button size="sm" data-testid={`merge-group-${i}`} onClick={() => merge(g, i)} className="bg-[#0073ea] hover:bg-[#0060c2] text-white">Merge into selected</Button>
          </div>
        ))}
      </DialogContent>
    </Dialog>
  );
}
